
/* This does not work reliably when built, as Vimeo seems to be arsing around
   with detecting module imports or something, so we include Vimeo in base.html
   via a script tag */
// import 'https://player.vimeo.com/api/player.js';

import 'slide-show/element.js';
import { open, close } from '../bolt/elements/dialog.js';
import delegate from 'dom/delegate.js';
import events   from 'dom/events.js';
import get      from 'fn/get.js';
import noop     from 'fn/noop.js';
import overload from 'fn/overload.js';
import Stream   from 'fn/stream/stream.js';


// Hack around Safari not rendering full backdrop behind backdrop blur
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) setTimeout(() => {
    const splash = document.querySelector('.splash-dialog');
    if (!splash) return;
    // Change dialog width forces re-render
    splash.style.width = (splash.clientWidth - 1) + 'px';
}, 3000);


// Remove splash dialog when it has finished animating
events('animationend', document)
.filter((e) => e.target.matches('.splash-dialog'))
.each((e) => e.target.remove());

// Select image in slide-show when media dialog is opened
events({ type: 'toggle', select: '#media-dialog', capture: true }, document)
.each((e) => {
    if (e.target.open) {
        e.target.querySelector('slide-show').active = e.source.dataset.mediaId;
    }
});

events('click', document)
.each(delegate({
    // Remove nav item order storage when a[data-reset] is clicked
    '[data-reset]': (link, e) => sessionStorage.removeItem('orders'),

    // Slide to previous or next slide when figure is clicked upon
    'slide-show': (slideshow, e) => {
        if (e.target.matches('.after')) {
            slideshow.activateNext();
            return;
        }

        if (e.target.closest('.before')) {
            slideshow.activatePrevious();
            return;
        }
    }
}));

// Track navigation scroll position, toggle tagline
const navigation = document.getElementById('navigation');

function addClass(element) {
    element.classList.add('scroll-0');
}

function removeClass(element) {
    element.classList.remove('scroll-0');
}

Stream.merge(
    [{}],
    events({ type: 'scroll', passive: true }, navigation)
)
.reduce((state, e) => {
    if (state !== false && navigation.scrollTop <= 0) {
        // Add class
        document.querySelectorAll('.scroll-hidden').forEach(addClass);
        return false;
    }

    if (state === false && navigation.scrollTop > 0) {
        // Remove class
        document.querySelectorAll('.scroll-hidden').forEach(removeClass);
        return true;
    }

    return state;
});

// Start and stop vimeo players as dialog opens and closes and slides activate
const vimeos = {};
Stream.merge(
    events({ type: 'toggle', select: '#media-dialog' }, document),
    events({ type: 'slide-active', select: '.media-slide-show' }, document)
)
.reduce((player, e) => {
    // Stop currently playing vimeo
    if (player) player.pause();

    // Dialog closed, no vimeo player to start
    if (e.type === 'toggle' && !e.target.open) return;

    // Get current slide
    const slide  = e.type === 'toggle' ?
        e.target.querySelector('slide-show').active :
        e.target ;

    // Detect vimeo iframe
    const iframe = slide.querySelector('iframe');
    if (!iframe) return;
    if (iframe.src.indexOf('vimeo.com') === -1) return;

    // Get vimeo player and play vimeo
    const vimeo = vimeos[slide.id] || (vimeos[slide.id] = new Vimeo.Player(iframe));
    vimeo.play();

    // Return player to next activation
    return vimeo;
});

events({ type: 'toggle', select: '.media-dialog', capture: true }, document)
.each((e) => {
    const frame = e.target.querySelector('iframe.video-autoplay');
    if (frame) {
        const vimeo = new Vimeo.Player(frame);
        if (e.target.open) {
            vimeo.play();
        } else {
            vimeo.pause();
        }
    }
})

// Arrow keys previous and next slides
events('keydown', document)
.each(overload(get('key'), {
    ArrowLeft:  (e) => {
        const slideshow = document.querySelector('dialog[open] > slide-show');
        if (!slideshow) return;
        slideshow.activatePrevious();
        e.preventDefault();
    },

    ArrowRight: (e) => {
        const slideshow = document.querySelector('dialog[open] > slide-show');
        if (!slideshow) return;
        slideshow.activateNext();
        e.preventDefault();
    },

    default: noop
}));
